export class Sube {

  id: number;
  isim: string;
  kodu: number;
  checked = false;
  talepSeri: string;
  teslimatAdresi: string;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

}
